<template>
  <div class="site_item align-vertical" :class="[item.f_site_type == 'O' ? 'site_new' : 'site_general']">
    <div
      v-if="isAdmin && isReport"
      class="auto_hide_waring bordered-view-confirm"
      :style="{ color: $c.Color.$trading1 }"
    >
      {{
        ['HC', 'HW'].indexOf(item.f_report_type) > -1 ?
          `${moment(item.f_report_date).format(
            "YY-MM-DD"
          )} / [ ${utils.getReportTypeText(item.f_report_type)}-${item.f_ho == null ? '삭제됨' : item.f_ho} ] / ${
            item.f_reporter_name
          } / ${utils.formatPhoneNumber(item.f_reporter_phone)}` :
          `${moment(item.f_report_date).format(
            "YY-MM-DD"
          )} / [ ${utils.getReportTypeText(item.f_report_type)} ] / ${
            item.f_reporter_name
          } / ${utils.formatPhoneNumber(item.f_reporter_phone)}`
      }}
      <br />
    </div>
    <div v-if="item.f_report_memo || item.f_report_memo_images" class="auto_hide_waring bordered-view-confirm">
      <span style="color:back;">제보내용</span>
      <b-button
        v-if="item.f_report_memo_images"
        class="button1"
        variant="none"
        style="width: 100px; margin-left: 20px"
        @click="galleryPopupShow = true"
      >첨부이미지 보기</b-button>
      <br/>
      <pre class="memo_text"
            v-if="item.f_report_memo">{{item.f_report_memo}}</pre>
    </div>

    <span
      v-if="isAdmin && Object.keys(item).includes('f_remain_notify_cnt')"
      class="available_notify"
      style="margin-bottom: -10px; margin-top: 10px"
    >
      {{
        u.format(
          $t("group.available_notify"),
          item.f_remain_notify_cnt > 0 ? item.f_remain_notify_cnt : 0
        )
      }}
    </span>
    <div
      v-if="
        Object.keys(item).includes('f_today_reported_cnt') &&
        item.f_today_reported_cnt > 0
      "
      class="align-horizontal flex_1"
      style="margin-top: 5px; margin-bottom: -10px"
    >
      <b-img
        :src="require('../../assets/image/ic_check_any_on@2x.png')"
        style="width: 22px"
      />
      <span class="auto_hide_warning" style="color: #cf0000; line-height: 15px">
        {{ $t("site_detail.already_reported_today") }}
      </span>
    </div>
    <div
      class="align-vertical"
      v-if="
        Object.keys(item).includes('f_report_type') &&
        item.f_report_type === 'US'
      "
    >
      <div class="align-vertical">
        <div
          class="cell_header"
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
          @click="onUpdate(true)"
        >
          <div class="align-horizontal">
            <div
              class="badge p-2 mr-2"
              style="
                display: flex;
                color: #457fff;
                border-color: #457fff;
                width: 70px;
                height: 30px;
              "
            >
              {{ $t("site_report.unregister") }}
            </div>
            <span style="font-size: 24px; font-family: 'KoreanGD15R'">{{
              item.f_name
            }}</span>
            <b-img
              style="
                margin-left: 12px;
                height: 19px;
                vertical-align: text-bottom;
                margin-right: 4px;
              "
              :src="require('../../assets/image/ic_address_detail@2x.png')"
            ></b-img>
            <span class="sale_address">{{ utils.getAddress(item) }}</span>
          </div>
          <div class="align-horizontal">
            <b-button
              v-if="isAdmin || item.f_confirm !== 'U'"
              style="width: 40px"
              @click="onUpdate(true)"
              class="button"
              >보기</b-button
            >
            <div v-if="isResult && item.f_confirm == 'U'">
              <b-button
                class="button mr-2"
                style="width: 60px; background-color: #bebdbd"
                @click="
                  ($event) => {
                    $event.stopPropagation();
                    onDelete();
                  }
                "
                >{{ $t("common.delete1") }}</b-button
              >
              <b-button
                class="button"
                style="width: 60px"
                variant="primary"
                @click="
                  ($event) => {
                    $event.stopPropagation();
                    onUpdate();
                  }
                "
                >{{ $t("common.modify1") }}</b-button
              >
            </div>
          </div>
        </div>
        <div v-if="isAdmin" class="buttons" style="margin-top: 0">
          <b-button
            variant="none"
            style="width: 60px"
            class="red_btn"
            @click="onPayOrReject('F')"
            >{{ $t("site_report.reject") }}</b-button
          >
          <b-button
            variant="none"
            style="width: 60px"
            class="button1"
            @click="onPayOrReject('T')"
            >{{ $t("site_report.payment") }}</b-button
          >
          <b-button
            v-for="i in 4"
            variant="none"
            style="width: 60px; opacity: 0"
            class="button"
            disabled
          />
        </div>
      </div>
    </div>
    <div class="align-vertical" v-else>
      <div class="align-vertical" @click="onCell">
        <div v-if="item.f_complete == 'Y'"  class="complete_mask">
          {{ $t("more.sale_complete1") }}
        </div>
        <div v-else>
          <div
            v-if="
          item.f_hidden == 'Y' ||
          (item.f_site_type == 'G' &&
            item.f_hidden == 'N' &&
            (item.f_user_idx == self.myinfo.uid ||
              (Object.keys(item).includes('f_can_manage') &&
                item.f_can_manage == 'Y')) &&
            expire_days <= 0)
        "
            class="complete_mask"
          >
            {{ $t("more.sale_hidden") }}
          </div>
        </div>
        <div
          class="cell_header"
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <div class="align-vertical">
            <div class="align-horizontal v_center">
            <span
              style="
                color: #cf0000;
                font-size: 20px;
                font-family: 'KoreanGD15R';
              "
            >{{ item.f_same_position == 1 ? "(겹침)" : "" }}</span
            >
              <span style="font-size: 18px; font-family: 'KoreanGD15R';width: 250px;">{{item.f_name}}</span>
            </div>
            <span v-if="hoMode && item.f_site_type === 'O'" class="ho_name_label">{{"[" + item.f_ho + "]"}}</span>
          </div>
          <div class="align-vertical margin-bottom-5">
            <div class="align-horizontal margin-bottom-5" style="display: inline;">
              <div style="text-align: right;">
                <b-img
                  style="
                  height: 16px;
                  vertical-align: text-bottom;
                  margin-right: 0px;
                "
                  :src="require('../../assets/image/ic_address_detail@2x.png')"
                ></b-img>
                <span class="sale_address">{{ utils.getAddress(item) }}</span>
              </div>
            </div>
            <div class="sale_date">
              {{ u.format($t("site_detail.update_date"), item.f_update_time ? item.f_update_time.substr(0, 10).replace("-", "-") : "") }}
            </div>
            <div class="align-vertical" v-show="false">
              <span class="sale_date"
              >{{ $t("interest.reg_date") }}
              {{
                  item.f_reg_time
                    ? item.f_reg_time.substr(0, 10).replace("-", "-")
                    : ""
                }}</span>
              <span class="sale_date">{{
                  item.f_site_type == "O"
                    ? $t("map.open_date")
                    : $t("map.open_date2")
                }}
              {{
                  item.f_open_date ? item.f_open_date.replace("-", "-") : ""
                }}</span>
            </div>
          </div>
        </div>
        <div class="sale_info align-horizontal">
          <div class="align-vertical h_center">
            <div class="align-horizontal cost_item" style=""
                 v-if="maemulTypes.indexOf($c.MAEMUL_TYPE.TRADING) > -1 && showTrading">
              <div class="badge" :style="{backgroundColor: $c.Color.$trading1}">
                {{
                  item.f_site_type == "O"
                    ? $t("site_detail.parcel_out")
                    : $t("interest.trading")
                }}
              </div>
              <div class="cost_info">
                <span v-if="(item.f_site_inquire_price == 'Y' || (item.f_sale_price_min == 0 && (item.f_site_type == 'O' && item.f_sale_price_max == 0)))">
                  {{ $t("site_detail.desc_inquire_site") }}
                </span>
                <span v-else>
                  <span v-if="![Infinity, -Infinity].includes(item.f_sale_price_min)">
                    {{ utils.currency_10000(item.f_sale_price_min) }}
                  </span>
                  <span v-if="item.f_site_type == 'O' && item.f_sale_price_max && ![Infinity, -Infinity].includes(item.f_sale_price_max)">
                    &nbsp;~&nbsp;
                    {{ utils.currency_10000(item.f_sale_price_max) }}
                  </span>
                </span>
              </div>
              <template v-if="item.f_site_type == 'G'">
                <div class="badge" :style="{backgroundColor: $c.Color.$trading1}">
                  {{$t("site_detail.collateral_short")}}
                </div>
                <div class="cost_info">
                  <span v-if="item.f_site_inquire_price == 'Y'">
                    {{ $t("site_detail.desc_inquire_site") }}
                  </span>
                  <span v-else>
                    {{ utils.currency_10000(item.f_collateral_price == null ? '' : item.f_collateral_price) }}
                  </span>
                </div>
              </template>
            </div>
            <div class="align-horizontal cost_item" v-if="maemulTypes.indexOf($c.MAEMUL_TYPE.CHARTER) > -1 && showCharter">
              <div class="badge" :style="{backgroundColor: $c.Color.$charter1}">
                {{ $t("interest.charter") }}
              </div>
              <div class="cost_info">
                <span v-if="(item.f_site_inquire_charter == 'Y' || (item.f_charter_price_min == 0 && (item.f_site_type == 'O' && item.f_charter_price_max == 0)))">
                  {{ $t("site_detail.desc_inquire_site") }}
                </span>
                <span v-else>
                  <span v-if="![Infinity, -Infinity].includes(item.f_charter_price_min)">
                    {{ utils.currency_10000(item.f_charter_price_min) }}
                  </span>
                  <span v-if="item.f_site_type == 'O' && item.f_charter_price_max && ![Infinity, -Infinity].includes(item.f_charter_price_max)">
                    &nbsp;~&nbsp;
                    {{ utils.currency_10000(item.f_charter_price_max) }}
                  </span>
                </span>
              </div>
            </div>
            <div class="align-horizontal cost_item" v-if="maemulTypes.indexOf($c.MAEMUL_TYPE.MONTHLY) > -1 && showMonth">
              <div class="badge" :style="{backgroundColor: $c.Color.$monthly1 }">
                {{ $t("interest.monthly") }}
              </div>
              <div class="cost_info">
                <span v-if="item.f_site_inquire_month == 'Y'">
                  <span v-if="month_simple">
                      {{$t('interest.desc_monthly')}}
                    </span>
                    <template v-else>
                      {{ $t("site_detail.desc_inquire_site") }}
                    </template>
                </span>
                <span v-else>
                  <template v-if="item.f_site_type == 'O' && !hoMode">
                    <span v-if="month_simple">
                      {{$t('interest.desc_monthly')}}
                    </span>
                    <template v-else>
                      <span v-if="![Infinity, -Infinity].includes(f_monthly_rent_deposit_min)">
                        {{($t("map.deposit") + " " + utils.currency_10000(f_monthly_rent_deposit_min))}}
                      </span>
                      <span v-if="f_monthly_rent_max && ![Infinity, -Infinity].includes(f_monthly_rent_max) ">
                        {{(" | " + $t("interest.monthly") + " " + utils.currency_10000(f_monthly_rent_max))}}
                      </span>
                    </template>
                  </template>
                  <template v-else>
                    <span v-if="month_simple">
                      {{$t('interest.desc_monthly')}}
                    </span>
                    <template v-else>
                      <span v-if="![Infinity, -Infinity].includes(f_monthly_rent_min)">
                        {{($t("map.deposit") + " " + utils.currency_10000(f_monthly_rent_min))}}
                      </span>
                      <span v-if="f_monthly_rent_max && ![Infinity, -Infinity].includes(f_monthly_rent_max)">
                        {{(" | " + $t("interest.monthly") + " " + utils.currency_10000(f_monthly_rent_max))}}
                      </span>
                    </template>
                  </template>
                </span>
              </div>
            </div>
            <div class="align-horizontal cost_item" v-if="maemulTypes.indexOf($c.MAEMUL_TYPE.INVEST) > -1 && showInvestment">
              <div class="badge" :style="{backgroundColor: $c.Color.$invest1}">
                {{ $t("interest.invest") }}
              </div>
              <div class="cost_info">
                <span v-if="(item.f_site_inquire_investment == 'Y' || (item.f_invest_price_min == 0 && (item.f_site_type == 'O' && item.f_invest_price_max == 0)))">
                  {{ $t("site_detail.desc_inquire_site") }}
                </span>
                <span v-else>
                  <span v-if="![Infinity, -Infinity].includes(item.f_invest_price_min)">
                    {{ utils.currency_10000(item.f_invest_price_min) }}
                  </span>
                  <span v-if="item.f_site_type == 'O' && item.f_invest_price_max && ![Infinity, -Infinity].includes(item.f_invest_price_max)">
                    &nbsp;~&nbsp;
                    {{ utils.currency_10000(item.f_invest_price_max) }}
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div class="align-vertical h_center">
            <div class="align-horizontal cost_item" v-if="maemulTypes.indexOf($c.MAEMUL_TYPE.TRADING) > -1 && showTrading">
              <div class="badge" :style="{backgroundColor: $c.Color.$trading1}">R</div>
              <div class="cost_info">
                <span v-if="item.f_site_type == 'O'">
                  {{ (item.f_fee_trading == '0' || feeTypes.indexOf($c.FEE_TYPES.TRADING) < 0 || item.f_fee_trading == null) ? $t("site_detail.site_inquire") : item.f_fee_trading }}
                </span>
                <span v-else>
                  <span v-if="(item.f_fee_site_inquire_price == 'Y')">
                    {{ $t("site_detail.site_inquire") }}
                  </span>
                  <span v-else>
                    {{((item.f_fee_trading_type == 2 ? $t('register.none_hit') : item.f_fee_trading_type == 1 ? $t('register.double_hit') : $t('register.single_hit')) + ((item.f_fee_trading == '0' || item.f_fee_trading == null) ? '' : ('+' + item.f_fee_trading)))}}
                  </span>
                </span>
              </div>
            </div>
            <div class="align-horizontal cost_item" v-if="maemulTypes.indexOf($c.MAEMUL_TYPE.CHARTER) > -1 && showCharter">
              <div class="badge" :style="{backgroundColor: $c.Color.$charter1}">R</div>
              <div class="cost_info">
                <span v-if="item.f_site_type == 'O'">
                  {{ ((feeTypes.indexOf($c.FEE_TYPES.CHARTER) < 0) ? $t('site_detail.site_inquire') : ((item.f_fee_charter_type == 2 ? $t('register.none_hit') : item.f_fee_charter_type == 1 ? $t('register.double_hit') : $t('register.single_hit')) + ((item.f_fee_charter == '0' || item.f_fee_charter == null) ? '' : ('+' + item.f_fee_charter)))) }}
                </span>
                <span v-else>
                  {{((item.f_fee_site_inquire_charter == 'Y') ? $t('site_detail.site_inquire') : ((item.f_fee_charter_type == 2 ? $t('register.none_hit') : (item.f_fee_charter_type == 1 ? $t('register.double_hit') : $t('register.single_hit'))) + ((item.f_fee_charter == '0' || item.f_fee_charter == null) ? '' : ('+' + item.f_fee_charter))))}}
                </span>
              </div>
            </div>
            <div class="align-horizontal cost_item" v-if="maemulTypes.indexOf($c.MAEMUL_TYPE.MONTHLY) > -1 && showMonth">
              <div class="badge" :style="{backgroundColor: $c.Color.$monthly1}">R</div>
              <div class="cost_info">
                <span v-if="item.f_site_type == 'O'">
                  {{ ((feeTypes.indexOf($c.FEE_TYPES.MONTHLY) < 0) ? $t('site_detail.site_inquire') : ((item.f_fee_monthly_type == 2 ? $t('register.none_hit') : item.f_fee_monthly_type == 1 ? $t('register.double_hit') : $t('register.single_hit')) +((item.f_fee_monthly == '0' || item.f_fee_monthly == null) ? '' : ('+' + item.f_fee_monthly)))) }}
                </span>
                <span v-else>
                  {{((item.f_fee_site_inquire_month == 'Y') ? $t('site_detail.site_inquire') : ((item.f_fee_monthly_type == 2 ? $t('register.none_hit') : item.f_fee_monthly_type == 1 ? $t('register.double_hit') : $t('register.single_hit')) + ((item.f_fee_monthly == '0' || item.f_fee_monthly == null) ? '' : ('+' + item.f_fee_monthly))))}}
                </span>
              </div>
            </div>
            <div class="align-horizontal cost_item" v-if="maemulTypes.indexOf($c.MAEMUL_TYPE.INVEST) > -1  && showInvestment">
              <div class="badge" :style="{backgroundColor: $c.Color.$invest1}">R</div>
              <div class="cost_info">
                <span v-if="item.f_site_type == 'O'">
                  {{ ((feeTypes.indexOf($c.FEE_TYPES.INVESTMENT) < 0) ? $t('site_detail.site_inquire') : item.f_fee_invest) }}
                </span>
                <span v-else>
                  {{(item.f_fee_site_inquire_investment == 'Y') ? $t('site_detail.site_inquire') : ((item.f_fee_invest_type == 2 ? $t('register.none_hit') : item.f_fee_invest_type == 1 ? $t('register.double_hit') : $t('register.single_hit')) + ((item.f_fee_invest == '0' || item.f_fee_invest == null) ? '' : ('+' + item.f_fee_invest)))}}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="sale_info align-horizontal" v-if="false">
          <div class="vertical-layout" style="width: 70%">
            <div class="align-horizontal cost_item" style="">
              <div
                class="badge"
                :style="{
                  borderColor:
                    maemulTypes.indexOf($c.MAEMUL_TYPE.TRADING) > -1
                      ? $c.Color.$trading
                      : '',
                  color:
                    maemulTypes.indexOf($c.MAEMUL_TYPE.TRADING) > -1
                      ? $c.Color.$trading
                      : '',
                }"
              >
                {{
                  item.f_site_type == "O"
                    ? $t("site_detail.parcel_out")
                    : $t("interest.trading")
                }}
              </div>
              <div
                class="cost_info"
                v-if="maemulTypes.indexOf(this.$c.MAEMUL_TYPE.TRADING) > -1"
              >
                <span v-if="item.f_site_inquire_price == 'Y'">
                  {{ $t("site_detail.desc_inquire_site") }}
                </span>
                <span v-else>
                  {{ utils.currency_10000(item.f_sale_price_min) }}
                  <span v-if="item.f_site_type == 'O'">
                    &nbsp;~&nbsp;
                    {{ utils.currency_10000(item.f_sale_price_max) }}
                  </span>
                </span>
              </div>
            </div>
            <div class="align-horizontal cost_item">
              <div
                class="badge"
                :style="{
                  borderColor:
                    maemulTypes.indexOf($c.MAEMUL_TYPE.CHARTER) > -1
                      ? $c.Color.$charter
                      : '',
                  color:
                    maemulTypes.indexOf($c.MAEMUL_TYPE.CHARTER) > -1
                      ? $c.Color.$charter
                      : '',
                }"
              >
                {{ $t("interest.charter") }}
              </div>
              <div
                class="cost_info"
                v-if="maemulTypes.indexOf($c.MAEMUL_TYPE.CHARTER) > -1"
              >
                <span v-if="item.f_site_inquire_charter == 'Y'">
                  {{ $t("site_detail.desc_inquire_site") }}
                </span>
                <span v-else>
                  {{ utils.currency_10000(item.f_charter_price_min) }}
                  <span v-if="item.f_site_type == 'O'">
                    &nbsp;~&nbsp;
                    {{ utils.currency_10000(item.f_charter_price_max) }}
                  </span>
                </span>
                <span
                  v-if="item.f_safe_charter == 'Y'"
                  class="charter_badge"
                  :style="{ backgroundColor: $c.Color.$primary }"
                >
                  {{ $t("interest.relief") }}
                </span>
                <span
                  v-if="item.f_smb == 'Y'"
                  class="charter_badge"
                  style="background-color: #039fb7"
                >
                  {{ $t("interest.smb") }}
                </span>
              </div>
            </div>
            <div class="align-horizontal cost_item">
              <div
                class="badge"
                :style="{
                  borderColor:
                    maemulTypes.indexOf($c.MAEMUL_TYPE.INVEST) > -1
                      ? $c.Color.$invest
                      : '',
                  color:
                    maemulTypes.indexOf($c.MAEMUL_TYPE.INVEST) > -1
                      ? $c.Color.$invest
                      : '',
                }"
              >
                {{ $t("interest.invest") }}
              </div>
              <div
                class="cost_info"
                v-if="maemulTypes.indexOf($c.MAEMUL_TYPE.INVEST) > -1"
              >
                <span v-if="item.f_site_inquire_investment == 'Y'">
                  {{ $t("site_detail.desc_inquire_site") }}
                </span>
                <span v-else>
                  {{ utils.currency_10000(item.f_invest_price_min) }}
                  <span v-if="item.f_site_type == 'O'">
                    &nbsp;~&nbsp;
                    {{ utils.currency_10000(item.f_invest_price_max) }}
                  </span>
                </span>
              </div>
            </div>
            <div class="align-horizontal cost_item">
              <div
                class="badge"
                :style="{
                  borderColor:
                    maemulTypes.indexOf($c.MAEMUL_TYPE.MONTHLY) > -1
                      ? $c.Color.$monthly
                      : '',
                  color:
                    maemulTypes.indexOf($c.MAEMUL_TYPE.MONTHLY) > -1
                      ? $c.Color.$monthly
                      : '',
                }"
              >
                {{ $t("interest.monthly") }}
              </div>
              <div
                class="cost_info"
                v-if="maemulTypes.indexOf($c.MAEMUL_TYPE.MONTHLY) > -1"
              >
                <span v-if="item.f_site_inquire_month == 'Y'">
                  {{ $t("site_detail.desc_inquire_site") }}
                </span>
                <template v-else>
                  <span v-if="month_simple">
                    {{$t('interest.desc_monthly')}}
                  </span>
                  <span v-else>
                    {{ $t("map.deposit") + " " }}
                    {{ utils.currency_10000(f_monthly_rent_min) + " | " }}
                    {{ $t("interest.monthly") + " " }}
                    {{ utils.currency_10000(f_monthly_rent_max) }}
                  </span>
                </template>
              </div>
            </div>
          </div>
          <div
            class="image_wrapper"
            :style="{
              backgroundImage:
                'url(' +
                (images.length
                  ? images[0].replace(new RegExp(/\\/g), '/')
                  : $c.IMAGE_FOO_URL) +
                ')',
            }"
          >
            <b-img
              @click="($event) => onLike($event)"
              v-if="showBtn && item.f_complete == 'N' && item.f_hidden == 'N'"
              class="top_right"
              style="width: 1.2em; height: 1.2em"
              :src="
                item.f_like == 'Y'
                  ? require('../../assets/image/ic_heart_on@2x.png')
                  : require('../../assets/image/ic_heart_off@2x.png')
              "
            >
            </b-img>
            <div v-if="item.f_complete == 'Y'" class="complete_mask">
              {{ $t("more.sale_complete1") }}
            </div>
            <div v-else>
              <div
                v-if="
                  item.f_hidden == 'Y' ||
                  (item.f_site_type == 'G' &&
                    item.f_hidden == 'N' &&
                    (item.f_user_idx == self.myinfo.uid ||
                      (Object.keys(item).includes('f_can_manage') &&
                        item.f_can_manage == 'Y')) &&
                    expire_days <= 0)
                "
                class="complete_mask"
              >
                {{ $t("more.sale_hidden") }}
              </div>
            </div>
          </div>
        </div>
        <div class="room_info align-horizontal" v-if="false">
          <div class="vertical-layout" style="width: 100%">
            <div v-if="item.f_site_type == 'O'">
              <div
                class="align-horizontal room_row"
                v-for="(it, idx) in roomList"
                :key="idx"
              >
                <span class="room_col" style="width: 30%">
                  {{
                    Number(it.f_room) > 4
                      ? $c.ROOM_NUM[5]
                      : $c.ROOM_NUM[(Number(it.f_room) % 5) + 1]
                  }}{{
                    it.f_duplex === "Y"
                      ? "(" + $t("room_info_popup.duplex") + ")"
                      : ""
                  }}
                </span>
                <div class="divider"></div>
                <span class="room_col" style="width: 151px">
                  {{ $t("room_info_popup.private_size") }}
                  {{
                    it.f_exclusive_pyong > 0
                      ? u.format($t("common.p"), it.f_exclusive_pyong)
                      : "-"
                  }}
                </span>
                <div class="divider"></div>
                <span class="room_col" style="width: 151px">
                  {{ $t("site_detail.real_size") }}
                  {{
                    it.f_real_pyong > 0
                      ? u.format($t("common.p"), it.f_real_pyong)
                      : "-"
                  }}
                </span>
              </div>
            </div>
            <div v-else>
              <div
                v-for="(it, idx) in roomList.slice(0, 1)"
                class="room_row"
                :key="idx"
              >
                <span class="room_col" style="width: 151px">
                  {{
                    Number(it.f_room) > 4
                      ? $c.ROOM_NUM[5]
                      : $c.ROOM_NUM[(Number(it.f_room) % 5) + 1]
                  }}{{
                    it.f_duplex === "Y"
                      ? "(" + $t("room_info_popup.duplex") + ")"
                      : ""
                  }}
                </span>
                <div class="divider"></div>
                <span class="room_col" style="width: 151px">
                  {{ $t("register.toilet1") }} {{ item.f_toilet_num }}
                  <span style="margin-left: -4px">{{
                    $t("room_info_popup.gae")
                  }}</span>
                  {{ Number(item.f_toilet_num) >= 3 ? $t("map.more") : "" }}
                </span>
                <div class="divider"></div>
                <span class="room_col" style="width: 151px">
                  {{ $t("room_info_popup.private_size") }}
                  {{
                    exclusiveAreaList.length > 0
                      ? u.format($t("common.p"), exclusiveAreaList[0])
                      : "-"
                  }}
                </span>
                <div class="divider"></div>
                <span class="room_col" style="width: 151px">
                  {{ $t("site_detail.real_size") }}
                  {{
                    realAreaList.length > 0
                      ? u.format($t("common.p"), realAreaList[0])
                      : "-"
                  }}
                </span>
                <div class="divider"></div>
                <span class="room_col" style="width: 151px">
                  {{ renderFeeType().replace("타", "+") }}
                </span>
                <!--          <span v-else  class="room_col red_text" style="width: 18%">-->
                <!--            {{item.f_recent_noti_ago_date == null ?-->
                <!--            $t("site_detail.no_recent_notification")-->
                <!--            : item.f_recent_noti_ago_date > 1 ?-->
                <!--                u.format($t("site_detail.recent_notification_days"), item.f_recent_noti_ago_date) :-->
                <!--                $t("site_detail.recent_notification_today")-->
                <!--            }}-->
                <!--          </span>-->
              </div>
            </div>
          </div>
          <div
            class="align-horizontal"
            v-if="item.f_site_type == 'O'"
            style="min-height: 22px; align-items: center"
          >
            <div
              class="divider"
              style="height: auto; min-height: 10px; margin: 5px 0"
            ></div>
            <div class="room_col" style="width: 151px">
              {{ renderFeeType().replace("타", "+") }}
            </div>
            <div
              class="divider"
              style="height: auto; min-height: 10px; margin: 5px 0"
            ></div>
            <div class="room_col" style="width: 151px">
              <span>
                <template v-if="item.f_ho_list.length > 0">
                  {{ u.format($t("interest.type"), getRoomType(item)) }}
                </template>
                <template v-else>
                  {{ $t("interest.no_room") }}
                </template>
              </span>
              <!--          <span v-else  class="room_col red_text">-->
              <!--            {{item.f_recent_noti_ago_date == null ?-->
              <!--            $t("site_detail.no_recent_notification")-->
              <!--            : item.f_recent_noti_ago_date > 1 ?-->
              <!--              u.format($t("site_detail.recent_notification_days"), item.f_recent_noti_ago_date) :-->
              <!--              $t("site_detail.recent_notification_today")-->
              <!--            }}-->
              <!--          </span>-->
            </div>
          </div>
        </div>
        <div v-if="false && item.f_memo != ''" class="align-horizontal memo_info">
          <b-img
            style="width: 1.1em; height: 1.3em; margin-bottom: 9px"
            :src="require('../../assets/image/ic_memo@2x.png')"
          ></b-img>
          <span class="memo">
            {{ replaceEnter(item.f_memo) }}
          </span>
        </div>
      </div>

      <div v-if="!isAdmin && isReport" class="buttons">
        <b-button
          variant="primary"
          class="button1"
          @click="onSiteReport('SC')"
          >{{ $t("site_report.site_completion") }}</b-button
        >
        <b-button
          variant="primary"
          class="button1"
          @click="onSiteReport('SS')"
          >{{ $t("site_report.site_shutdown") }}</b-button
        >
        <b-button
          variant="primary"
          class="button1"
          @click="onSiteReport('SR')"
          >{{ $t("site_report.site_resumption") }}</b-button
        >
        <b-button
          variant="primary"
          class="button1"
          @click="onSiteReport('STC')"
          >{{ $t("site_report.sales_team_change") }}</b-button
        >
        <b-button
          variant="primary"
          class="button1"
          @click="onSiteReport('PC')"
          >{{ $t("site_report.price_change") }}</b-button
        >
      </div>
      <div v-if="isAdmin && isReport" class="buttons">
        <!--    <div  class="buttons">-->
        <b-button
          variant="none"
          style="width: 60px"
          class="red_btn"
          @click="onPayOrReject('F')"
          >{{ $t("site_report.reject") }}</b-button
        >
        <b-button
          variant="none"
          style="width: 60px"
          class="button1"
          @click="onPayOrReject('T')"
          >{{ $t("site_report.payment") }}</b-button
        >
        <b-button
          variant="none"
          style="width: 60px"
          class="button"
          @click="showSetSaleCompletePopup = true"
          >{{ $t("site_report.site_completion1") }}</b-button
        >
        <b-button
          variant="none"
          style="width: 60px"
          class="button"
          @click="showTransferPopup = true"
          >{{ $t("site_report.site_transfer") }}</b-button
        >
        <b-button
          style="width: 60px"
          :variant="[item.f_hidden == 'Y' ? 'secondary' : 'primary']"
          :class="[item.f_hidden == 'Y' ? 'grey_button' : 'button']"
          @click="onHidden"
        >
          {{
            item.f_hidden == "Y" ? $t("more.show") : $t("more.hide")
          }}</b-button
        >
        <b-button
          variant="primary"
          style="width: 60px"
          class="button"
          @click="onUpdate"
          >{{ $t("common.modify") }}</b-button
        >
      </div>

      <div v-if="showBtn" class="buttons">
        <div class="align-horizontal"
             v-if="isAdmin"
             style="margin-right: 26px;">
          <b-button
            @click="onDelete"
            class="button"
            :style="{ backgroundColor: $c.Color.$trading1 }"
          >
            {{ $t("admin.delete") }}
          </b-button>
          <b-button
            @click="onHidden"
            :class="[item.f_hidden == 'Y' ? 'grey_button' : 'button']"
            :variant="[item.f_hidden == 'Y' ? 'secondary' : 'primary']"
            style="background-color: #0840ba !important;"
          >
            {{ item.f_hidden == "Y" ? $t("more.show") : $t("more.hide") }}
          </b-button>
        </div>
        <b-button v-else @click="onNotify" variant="primary" class="button" v-show="false">
          <!--//???-->
          {{ $t("interest.site_notify") }}
        </b-button>
        <b-button
          @click="onLike()"
          variant="primary"
          v-if="!isAdmin"
          class="button"
          style="width: 2.2rem;"
        >
          <b-img
              style="width: 1.2em; height: 1.2em"
              :src="
                item.f_like == 'Y'
                  ? require('../../assets/image/ic_heart_on@2x.png')
                  : require('../../assets/image/ic_heart_off@2x.png')
              "></b-img>
        </b-button>
        <b-button
          @click="onCompleteReport"
          variant="primary"
          v-if="!isAdmin && item.f_site_type === 'O'"
          class="button"
        >
          {{ $t("map.site_report") }}
        </b-button>
        <b-button
          @click="onCompleteReport2"
          variant="primary"
          v-if="!isAdmin && item.f_site_type === 'G'"
          class="button"
        >
          {{ $t("map.site_report2") }}
        </b-button>
        <!--<div v-else class="button" style="opacity: 0" />-->
        <b-button
          variant="none"
          v-if="isAdmin && item.f_site_type === 'G'"
          style="display:block;width: 105px;"
        ></b-button>
        <div
          v-if="!isAdmin"
          class="align-horizontal"
          style="margin-left: auto"
        >
          <b-button @click="onCall()" class="button1" variant="">
            {{ $t("interest.call_phone") }}
          </b-button>
          <b-button @click="onNavi()" class="button1" variant="" style="margin-right:0;">
            {{ $t("interest.navi_connect") }}
          </b-button>
        </div>
        <template v-if="isAdmin" class="align-horizontal">
          <b-button
            v-if="isUpdateSale"
            variant="none"
            class="button"
            @click="showTransferPopup = true"
          >{{ $t("site_report.site_transfer") }}</b-button>
          <template v-if="!isUpdateSale">
            <b-button
              variant="secondary"
              v-if="item.f_group_idx && self.myinfo.uid == item.f_user_idx"
              @click="onShareRelease"
              class="button"
              style="margin-left: 5px; background-color: #bebdbd"
            >
              {{ $t("group.share_release") }}
            </b-button>
            <div v-else>
              <b-button
                variant="primary"
                v-if="utils.isEmpty(item.f_group_idx)"
                @click="onShare"
                class="button"
                style="margin-left: 0px"
              >
                {{ $t("group.group_share") }}
              </b-button>
              <b-button
                variant="primary"
                v-else
                class="button"
                style="margin-left: 0px; visibility: hidden"
              >
                {{ $t("group.group_share") }}
              </b-button>
            </div>
          </template>
          <b-button
            variant="primary"
            style="margin-left: 0px"
            class="button"
            v-if="item.f_site_type == 'O'"
            @click="showSetSaleCompletePopup = true"
          >{{ $t("site_report.site_completion1") }}</b-button
          >
          <b-button
            @click="onUpdate"
            class="button"
            style="margin-left: 0px; margin-right: 0"
            variant="primary"
          >
            {{ $t("common.modify") }}
          </b-button>
        </template>
      </div>

      <!-- 매물관리 created by J -->
      <div v-if="showAdminBtn == 'D' || showAdminBtn == 'H' || showAdminBtn == 'C'" class="buttons">
        <div class="align-horizontal"
             v-if="isAdmin">
          <b-button
            @click="onDeleteForever"
            class="button2"
            :style="{ backgroundColor: $c.Color.$trading1 }"
          >
            완전삭제
          </b-button>
        </div>

        <div style="flex: 1;"></div>

        <template v-if="isAdmin" class="align-horizontal">
          <b-button
            variant="none"
            class="button2"
            @click="showTransferPopup = true"
          >{{ $t("site_report.site_transfer") }}</b-button>

          <b-button
            v-if="showAdminBtn == 'D'"
            @click="onRestoreHidden"
            class="button2"
            variant="primary"
            style="background-color: #0840ba !important;"
          >
            현장복구+숨김
          </b-button>

          <b-button
          v-if="showAdminBtn == 'D'"
            @click="onRestore"
            class="button2"
            variant="primary"
            style="background-color: #0840ba !important; margin-right: 0px !important;"
          >
            현장복구
          </b-button>

          <b-button
          v-if="showAdminBtn == 'H'"
            @click="onShow"
            class="button2"
            variant="primary"
            style="background-color: #6b6b6b !important; margin-right: 0px !important;"
          >
            표시
          </b-button>

          <b-button
            v-if="showAdminBtn == 'C'"
            variant="primary"
            class="button2"
            @click="showSetSaleCompletePopup = true"
          >{{ $t("site_report.site_completion1") }}</b-button
          >
          <b-button
            v-if="showAdminBtn == 'C'"
            @click="onUpdate"
            class="button2"
            variant="primary"
            style="margin-right: 0px !important;"
          >
            {{ $t("common.modify") }}
          </b-button>
        </template>
      </div>

      <div
        v-if="
          item.f_site_type == 'G' &&
          item.f_hidden == 'N' &&
          (item.f_user_idx == self.myinfo.uid ||
            (Object.keys(item).includes('f_can_manage') &&
              item.f_can_manage == 'Y'))
        "
        :style="{
          justifyContent:
            item.f_user_idx == myinfo.uid ? 'space-between' : 'center', zIndex:0, backgroundColor: 'white'
        }"
        class="align-horizontal bordered-view"
      >
        <div class="align-horizontal flex_1 center">
          <span
            class="auto_hide_waring"
            :style="{ color: expire_days < 6 ? $c.Color.$trading1 : '' }"
          >
            {{
              expire_days <= 0
                ? $t("more.auto_hidden_maemul")
                : u.format($t("more.auto_hide_waring"), expire_days)
            }}
          </span>
        </div>
        <b-button
          @click="onUpdate_general(item.f_idx)"
          class="button"
          :style="{
            backgroundColor:
              expire_days < 6 ? $c.Color.$trading1 : $c.Color.$c_457fff,
          }"
        >
          {{ $t("admin.update1") }}
        </b-button>
      </div>
    </div>

    <div v-if="isResult && Object.keys(item).includes('f_report_result_list')">
      <div
        v-for="(report_result, i) in item.f_report_result_list"
        :key="i"
        v-if="report_result.f_result_type != 'U'"
      >
        <div
          class="auto_hide_waring bordered-view-result pt-1 pb-1"
          :style="{ color: report_result.f_result_type == 'T' ? $c.Color.$logo:$c.Color.$trading1, textAlign: 'center' }"
        >
          {{
            report_result.f_result_type == "T"
              ? report_result.f_report_type == "US"
                ? `${moment(report_result.f_result_date).format(
                    "MM/DD"
                  )} ${u.format(
                    $t("site_report.accept_report_unregister"),
                    1000
                  )}`
                : `${moment(report_result.f_result_date).format(
                    "MM/DD"
                  )} ${['HC', 'HW'].includes(report_result.f_report_type) ?
                  u.format(
                    $t("site_report.accept_report_ho"),
                    utils.getReportTypeText(report_result.f_report_type), report_result.f_ho
                  ) :
                  u.format(
                    $t("site_report.accept_report"),
                    utils.getReportTypeText(report_result.f_report_type)
                  )}`
              : `${moment(report_result.f_result_date).format(
                  "MM/DD"
                )} ${['HC', 'HW'].includes(report_result.f_report_type) ?
                u.format(
                  $t("site_report.reject_report_ho"),
                  utils.getReportTypeText(report_result.f_report_type), report_result.f_ho
                ) :
                u.format(
                  $t("site_report.reject_report"),
                  utils.getReportTypeText(report_result.f_report_type)
                )
              }`
          }}
        </div>
      </div>
    </div>
    <div
      class="
        sale_address
        border-trading
        color-trading
        border-charter
        color-charter
      "
    ></div>
    <Gallery :visible.sync="galleryPopupShow" :src="memoImages" :current="0"/>
    <ConfirmPopupGroup ref="confirm" />
    <SelectGroupPopup ref="select_group" />
    <SetSaleCompletePopup
      :visible.sync="showSetSaleCompletePopup"
      :site_idx="item.f_idx"
      @onCancel="
        u.setState(self, {
          showSetSaleCompletePopup: false,
        })
      "
    />
    <TransferPopup
      :visible.sync="showTransferPopup"
      :item="item"
      @remove="
        (idx) => {
          if (isTransfer) self.$emit('remove', idx);
        }
      "
    />
    <SiteDetail
      v-if="siteDetailData != null"
      :detailPopupAlign="detailPopupAlign ? detailPopupAlign : 'center'"
      :visible.sync="showSiteDetailPopup"
      :site="siteDetailData"
      :page="pageName"
    />
  </div>
</template>

<script>
import Utils from "../../config/utils";
const utils = require("util");
import { IS_TMP_MODE, IS_UI_MODE } from "../../config/constant";
import moment from "moment/moment";
import ConfirmPopupGroup from "./popup/ConfirmPopupGroup";
import SelectGroupPopup from "./popup/SelectGroupPopup";
import TransferPopup from "./popup/TransferPopup";
import SetSaleCompletePopup from "./popup/SetSaleCompletePopup";
import SiteDetail from "../contents/main/interest/SiteDetail";
import Gallery from "./Gallery.vue";

export default {
  name: "SiteItem",
  components: {
    Gallery,
    SetSaleCompletePopup,
    SiteDetail,
    TransferPopup,
    SelectGroupPopup,
    ConfirmPopupGroup,
  },
  props: [
    "item",
    "isAdmin",
    "isUpdateSale",
    "showAdminBtn",
    "showBtn",
    "isReport",
    "isResult",
    "isTransfer",
    "onlySelect",
    "hoMode",
    "detailPopupAlign",
    "pageName"
  ],
  inject: ["eventBus"],
  data() {
    return {
      is_tmp_mode: IS_TMP_MODE,
      u: utils,
      self: this,
      moment: moment,
      maemulTypes: [],
      feeTypes: [],
      utils: Utils,
      images: [],
      roomList: [],
      exclusiveAreaList: [],
      realAreaList: [],

      expire_days: 0,
      showSiteDetailPopup: false,
      siteDetailData: null,
      showSetSaleCompletePopup: false,
      showTransferPopup: false,
      reportType: null,
      showDetailNotifyPopup: false,
      notify: {},
      showExtendPopup: false,
      showTrading: true,
      showCharter: true,
      showInvestment: true,
      showMonth: true,
      available_ho_cnt: 0,
      month_simple: false,
      f_monthly_rent_deposit_min: -Infinity,
      f_monthly_rent_deposit_max: Infinity,
      f_monthly_rent_min: -Infinity,
      f_monthly_rent_max: Infinity,
      galleryPopupShow: false,
      memoImages:  this.item.f_report_memo_images
        ? this.item.f_report_memo_images.split(",").filter((it) => {
          return it != "";
        })
        : [],
    };
  },

  methods: {
    onCell() {
      if (this.onlySelect) {
        this.$emit("onCell");
        return;
      } else {
        if (this.isTransfer) {
          this.showTransferPopup = true;
          return;
        }
        Utils.requestGet(this.$c.API.Site.getSiteDetail, {
          site_idx: this.item.f_idx,
          skip_log_recent_view: this.$store.getters.getAdminMode,
        }).then((result) => {
          if (result.code == this.$c.API_RES_CODE.SUCCESS) {
            // this.$router.push({name: 'SiteDetail', params: {
            //     site: result.data
            //   }});
            this.siteDetailData = result.data;
            this.showSiteDetailPopup = true;
            if (result.data.isHidden) {
              Utils.toast(this, this.$t("common.deleted_hidden_site"));
            }
          } else {
            Utils.toast(this, result.msg);
          }
        });
      }
    },

    onLike(e) {
      if (e != undefined) e.stopPropagation();
      Utils.requestPost(this.$c.API.Site.setLikeSite, {
        site_idx: this.item.f_idx,
        like_status: this.item.f_like == "Y" ? "N" : "Y",
      }).then((result) => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.$emit("like", this.item);
          this.item.f_like = this.item.f_like == "Y" ? "N" : "Y";
        } else {
          Utils.toast(this, result.msg);
        }
      });
      return false;
    },

    onShareRelease() {
      Utils.showConfirm(
        this,
        this.$t("group.release_site_group_question") +
          "<br>" +
          "<span style='color:#cf0000;font-size: 20px;line-height: 2.5;'>" +
          this.$t("group.no_sites_in_group") +
          "</span>"
      ).then((value) => {
        if (value) {
          Utils.requestGet(this.$c.API.Group.releaseSiteFromGroup, {
            site_idx: this.item.f_idx,
          }).then((result) => {
            if (result.code == this.$c.API_RES_CODE.SUCCESS) {
              this.$emit("onToggleShareRelease", null);
              Utils.toast(this, this.$t("group.release_success"));
            } else Utils.toast(this, result.msg);
          });
        }
      });
    },

    onShare() {
      this.$refs.select_group.show(
        this.item.f_name,
        Utils.getAddress(this.item, true),
        (group, gotoGroup = false) => {
          if (gotoGroup) this.eventBus.$emit("gotoGroup");
          else {
            Utils.requestGet(this.$c.API.Group.shareSiteToGroup, {
              site_idx: this.item.f_idx,
              group_idx: group.f_idx,
            }).then((result) => {
              if (result.code == this.$c.API_RES_CODE.SUCCESS) {
                this.$emit("onToggleShareRelease", group.f_idx);
                Utils.toast(this, this.$t("group.share_success"));
              } else Utils.toast(this, result.msg);
            });
          }
        }
      );
    },

    onUpdate_general(site_idx) {
      Utils.requestGet(this.$c.API.Site.expandGeneralSiteExpireDays, {
        site_idx: site_idx,
      }).then((result) => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          // this.expire_days = 15;
          this.$emit("refresh");
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },

    sort(a, b) {
      if (a.f_room != b.f_room) {
        return a.f_room < b.f_room ? 1 : -1;
      }
      if (a.f_real_pyong > 0 || b.f_real_pyong > 0) {
        if (a.f_real_pyong != b.f_real_pyong) {
          return a.f_real_pyong < b.f_real_pyong ? 1 : -1;
        }
      }
      if (a.f_exclusive_pyong > 0 || b.f_exclusive_pyong > 0) {
        if (a.f_exclusive_pyong != b.f_exclusive_pyong) {
          return a.f_exclusive_pyong < b.f_exclusive_pyong ? 1 : -1;
        }
      }
      if (a.f_duplex != b.f_duplex) {
        return a.f_duplex > b.f_duplex ? 1 : -1;
      }
      return 0;
    },

    getRoomType(item) {
      let result = [];
      item.f_ho_list.forEach((it) => {
        if (
          !result.some((it1) => {
            return (
              it.f_room == it1.f_room &&
              it.f_toilet == it1.f_toilet &&
              it.f_veranda == it1.f_veranda &&
              it.f_utility_room == it1.f_utility_room &&
              it.f_duplex == it1.f_duplex &&
              it.f_teras == it1.f_teras &&
              it.f_exclusive_size == it1.f_exclusive_size &&
              it.f_real_size == it1.f_real_size
            );
          })
        ) {
          result.push(it);
        }
      });

      return result.length;
    },

    replaceEnter(text) {
      return text.replace(/\n/g, " ");
    },

    renderFeeType() {
      let feeTypes = this.item.f_fee_type.split(",").filter((it) => {
        return it != "";
      });

      let result = "";
      if (feeTypes.includes("T")) {
        result = "R " + this.item.f_fee_trading;
      } else if (feeTypes.includes("C")) {
        result =
          (this.item.f_fee_charter_type == 2
            ? this.$t("register.none_hit")
            : this.item.f_fee_charter_type == 1 ? this.$t("register.double_hit") : this.$t("register.single_hit")) +
          "" +
          this.item.f_fee_charter;
      } else if (feeTypes.includes("I")) {
        result = this.$t("interest.invest") + " " + this.item.f_fee_invest;
      } else if (feeTypes.includes("S")) {
        result = this.$t("map.site_check");
      } else if (feeTypes.includes("O")) {
        result = this.$t("map.court");
      }

      return result + (feeTypes.length > 1 ? " +" : "");
    },

    onCall() {
      if (this.item.f_contact_list.length > 0) {
        // Linking.openURL(`tel:${item.f_contact_list[0].f_phone}`);
        Utils.callPhone(
          this,
          this.item.f_contact_list[0].f_phone,
          this.item.f_contact_list[0].f_name
        );
      } else {
        Utils.toast(this, this.$t("interest.no_contact"));
      }
    },

    onHidden() {
      let state = this.item.f_hidden == "Y" ? "N" : "Y";
      Utils.requestPost(this.$c.API.Site.setHideSite, {
        site_idx: this.item.f_idx,
        hidden_status: state,
      }).then((result) => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          if (this.item.f_hidden == "N") {
            this.expire_days = 15;
          }
          this.item.f_hidden = state;
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },

    onCompleteReport() {
      this.$emit("completeReport", this.item);
    },

    onCompleteReport2() {
      Utils.showConfirm2(
        this,
        '<p style="font-size: 1em;">' +
          this.$t("interest.report_title") +
          "</p>" +
          '<p style="font-size: 0.9em; color:#cf0000;margin-bottom: 0;">' +
          this.$t("interest.report_confirm1") +
          "</p>"
      ).then((val) => {
        if (val) {
          Utils.requestPost(this.$c.API.Site.setCompleteSite, {
            site_idx: this.item.f_idx,
            complete_status: "Y", // TODO: 정확한 분양완료상태
          }).then((result) => {
            if (result.code == this.$c.API_RES_CODE.SUCCESS) {
              Utils.toast(this, this.$t("interest.report_confirm_click2"));
              // this.props.onCompleteReport();
            } else {
              Utils.toast(this, result.msg);
            }
          });
        }
      });
    },

    onNavi() {
      // TODO: navigation실행
      Utils.onNavi(
        this,
        this.item.f_longitude,
        this.item.f_latitude,
        this.item.f_address1,
        this.item.f_address1
      );
    },

    onDelete() {
      Utils.showConfirm(
        this,
        this.$t("admin.confirm_delete_sale") +
          "<br/>" +
          "<span style='color:#cf0000; font-size: 22px; line-height: 2.5;'>" +
          this.$t("admin.confirm_delete_sale_content") +
          "</span>"
      ).then((val) => {
        if (val) {
          Utils.requestPost(this.$c.API.Site.removeSite, {
            site_idx: this.item.f_idx,
          }).then((result) => {
            if (result.code == this.$c.API_RES_CODE.SUCCESS) {
              Utils.toast(this, this.$t("common.delete_success"));
              this.$emit("remove", this.item.f_idx);
            } else {
              Utils.toast(this, result.msg);
            }
          });
        }
      });
    },

    onDeleteForever() {
      Utils.showConfirm(
        this,
        this.$t("admin.confirm_delete_sale") +
          "<br/>" +
          "<span style='color:#cf0000; font-size: 22px; line-height: 2.5;'>" +
          this.$t("admin.confirm_delete_sale_content") +
          "</span>"
      ).then((val) => {
        if (val) {
          Utils.requestPost(this.$c.API.Site.removeSiteForever, {
            site_idx: this.item.f_idx,
          }).then((result) => {
            if (result.code == this.$c.API_RES_CODE.SUCCESS) {
              Utils.toast(this, this.$t("common.delete_success"));
              this.$emit("remove", this.item.f_idx);
            } else {
              Utils.toast(this, result.msg);
            }
          });
        }
      });
    },

    onRestoreHidden() {
      Utils.requestPost(this.$c.API.Site.restoreAndHiddenSite, {
        site_idx: this.item.f_idx,
        hidden: 'Y',
      }).then((result) => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          Utils.toast(this, "현장복구+숨김 처리되었습니다.");
          this.$emit("remove", this.item.f_idx);
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },

    onRestore() {
      Utils.requestPost(this.$c.API.Site.restoreAndHiddenSite, {
        site_idx: this.item.f_idx,
        hidden: 'N',
      }).then((result) => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          Utils.toast(this, "현장복구 처리되었습니다.");
          this.$emit("remove", this.item.f_idx);
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },

    onShow() {
      Utils.requestPost(this.$c.API.Site.setHideSite, {
        site_idx: this.item.f_idx,
        hidden_status: 'N',
      }).then((result) => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          Utils.toast(this, "표시 처리되었습니다.");
          this.$emit("remove", this.item.f_idx);
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },

    onUpdate(isReadOnly = false) {
      // TODO: go to update sale page
      Utils.requestGet(this.$c.API.Site.getSiteDetail, {
        site_idx: this.item.f_idx,
      }).then((result) => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          let data = result.data;
          Utils.requestGet(this.$c.API.Site.getSiteDetail, {
            site_idx: data.common.f_idx,
          }).then((result) => {
            if (result.code == this.$c.API_RES_CODE.SUCCESS) {
              if (result.data.common.f_site_type === "G") {
                this.$router.push({
                  name: "RegSite1",
                  params: {
                    type: "General",
                    common: result.data.common,
                    contact_list: result.data.contact_list,
                    room_list: result.data.room_list,
                  },
                });
              } else if (result.data.common.f_site_type === "U") {
                this.$router.push({
                  name: "UnregisteredSite",
                  params: {
                    isReadOnly: isReadOnly,
                    common: result.data.common,
                    contact_list: result.data.contact_list,
                    room_list: result.data.room_list,
                  },
                });
              } else if (result.data.common.f_site_type === "O") {
                this.$router.push({
                  name: "RegSite1",
                  params: {
                    type: "New",
                    isReadOnly: false,
                    common: result.data.common,
                    ho_list: result.data.ho_list,
                    dong_list: result.data.dong_list,
                    contact_list: result.data.contact_list,
                    room_list: result.data.room_list,
                  },
                });
              }
            }
          });
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },

    onSiteReport(report_type) {
      // this.setState({showSiteReportPopup: false}, ()=>{
      let msg = this.$t("site_report.report_inaccurate_disadvantage");
      if (report_type == "SC") {
        msg = this.$t("site_report.report_inaccurate_disadvantage1");
      }
      Utils.showConfirm(
        this,
        "[" +
          Utils.getReportTypeText(report_type) +
          "] " +
          this.$t("site_report.ask_report") +
          "<br/>" +
          "<span style='color:#cf0000;font-size: 22px;line-height: 60px;'>" +
          msg +
          "</span>"
      ).then((val) => {
        if (val) {
          Utils.requestPost(this.$c.API.Site.reportSite, {
            site_idx: this.item.f_idx,
            report_type: report_type,
            complete_status: "Y", // TODO: 정확한 분양완료상태
          }).then((result) => {
            if (result.code == this.$c.API_RES_CODE.SUCCESS) {
              Utils.toast(
                this,
                `[${Utils.getReportTypeText(report_type)}] ${this.$t(
                  "interest.report_confirm_click"
                )}`
              );
              // this.props.onCompleteReport();
            } else {
              Utils.toast.show(this, result.msg);
            }
          });
        }
      });
    },

    onPayOrReject(type) {
      Utils.requestGet(this.$c.API.Admin.payOrRejectForReport, {
        report_idx: this.item.f_report_idx,
        type: type,
      }).then((result) => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.$emit("remove", this.item.f_report_idx);
          Utils.toast(
            this,
            type == "T"
              ? this.$t("site_report.pay_success")
              : this.$t("site_report.reject_success")
          );
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },
    onNotify() {
      this.$store.commit("setSiteForNotifyList", this.item.f_idx);
      this.$store.commit("setForceHideMainBottomBar", true);
      //페지이행
      Utils.navigate(this, "/notify");
      // Utils.requestGet(this.$c.API.Notify.getRecentNotifyDetailBySite, {site_idx: this.item.f_idx}).then(result => {
      //   if (result.code == this.$c.API_RES_CODE.SUCCESS){
      //     this.notify = result.data.info;
      //     this.showDetailNotifyPopup = true;
      //   } else if (result.code == this.$c.API_RES_CODE.ERR_API)
      //     Utils.toast(this, this.$t('more.no_notify'));
      // });
    },
    init_component() {
      this.expire_days = this.item.f_remain_days_till_hide;

      let {item} = this;

      this.images = !item.f_image_urls
        ? []
        : this.item.f_image_urls.split(",").filter((it) => {
          return it != "";
        });

      // toilet num 은 다중선택가능하므로 제일 큰것만을 현시...
      item.f_toilet_num = this.item.f_toilet_num ? this.item.f_toilet_num.substr(this.item.f_toilet_num.lastIndexOf(',') + 1) : '';
      this.feeTypes = item.f_fee_type.split(',');
      if (item.f_site_type == 'G') {
        this.maemulTypes = !item.f_transaction_type ? [] : item.f_transaction_type.split(',')
          .filter(it => {
            return it != '';
          })
          .map(it => {
            return Number(it);
          });
      }
      console.log("f_idx == " + item.f_idx);
      var item_ho_list = item.f_ho_list;
      if (item.f_site_type == 'O')
      {
        if (!this.hoMode) {
          if (item.f_ho_list != undefined && item.f_ho_list.length != 0) {
            item.f_ho_list.forEach((ho) => {
              ho.f_trans_type.split(',')
                .filter(it => {
                  return it != '';
                }).forEach(it => {
                if (this.maemulTypes.indexOf(Number(it)) < 0)
                  this.maemulTypes.push(Number(it))
              })
            })
          } else {
            item_ho_list = item.f_ho_list2;
            item.f_ho_list2.forEach((ho) => {
              ho.f_trans_type.split(',')
                .filter(it => {
                  return it != '';
                }).forEach(it => {
                if (this.maemulTypes.indexOf(Number(it)) < 0)
                  this.maemulTypes.push(Number(it))
              })
            })
          }
        } else {
          this.maemulTypes = !item.f_transaction_type ? [] : item.f_transaction_type.split(',')
            .filter(it => {
              return it != '';
            })
            .map(it => {
              return Number(it);
            });
        }
      }

      // toilet num 은 다중선택가능하므로 제일 큰것만을 현시...
      item.f_toilet_num = item.f_toilet_num ? item.f_toilet_num.substr(item.f_toilet_num.lastIndexOf(',') + 1) : '';
      this.available_ho_cnt = 0;
      console.log("f_name == " + item.f_name);
      //console.log("item_ho_list");
      console.log(item_ho_list);
      if (!this.hoMode && item_ho_list.length >= 1 && item.f_site_type == 'O') {
        this.available_ho_cnt = item_ho_list.filter(it => {return it.f_complete == 'N'}).length;
        let sale_price_list = item_ho_list.filter(it => {return it.f_complete == 'N' && it.f_site_inquire_price != 'Y' && it.f_trans_type.split(',').includes(String(this.$c.MAEMUL_TYPE.TRADING))}).map(it => Number(it.f_sale_price))
        let collateral_price_list = item_ho_list.filter(it => {return it.f_complete == 'N'  && it.f_site_inquire_price != 'Y' && it.f_trans_type.split(',').includes(String(this.$c.MAEMUL_TYPE.TRADING))}).map(it => Number(it.f_collateral_price))
        let charter_price_list = item_ho_list.filter(it => {return it.f_complete == 'N' && it.f_site_inquire_charter != 'Y' && it.f_trans_type.split(',').includes(String(this.$c.MAEMUL_TYPE.CHARTER))}).map(it => Number(it.f_charter_price))
        let invest_price_list = item_ho_list.filter(it => {return it.f_complete == 'N' && it.f_site_inquire_investment != 'Y' && it.f_trans_type.split(',').includes(String(this.$c.MAEMUL_TYPE.INVEST))}).map(it => Number(it.f_investment_price))
        let month_rent_price_list = item_ho_list.filter(it => {return it.f_complete == 'N' && it.f_site_inquire_month != 'Y' && it.f_trans_type.split(',').includes(String(this.$c.MAEMUL_TYPE.MONTHLY))}).map(it => Number(it.f_monthly_rent))
        let month_rent_deposit_price_list = item_ho_list.filter(it => {return it.f_complete == 'N' && it.f_site_inquire_month != 'Y' && it.f_trans_type.split(',').includes(String(this.$c.MAEMUL_TYPE.MONTHLY))}).map(it => Number(it.f_monthly_rent_deposit))

        item.f_sale_price_min = Math.min(...sale_price_list)
        item.f_sale_price_max = Math.max(...sale_price_list)
        item.f_charter_price_min = Math.min(...charter_price_list)
        item.f_charter_price_max = Math.max(...charter_price_list)
        item.f_invest_price_min = Math.min(...invest_price_list)
        item.f_invest_price_max = Math.max(...invest_price_list)
        //TODO: 신축현장인 경우 월세와 보증금도 세대들의 월세와 보증금들의 범위형식으로 값을 주어야 하지 않는지???
        this.f_monthly_rent_deposit_min = Math.min(...month_rent_deposit_price_list) // 월세보증금
        this.f_monthly_rent_deposit_max = Math.max(...month_rent_deposit_price_list) // 월세보증금
        this.f_monthly_rent_min = Math.min(...month_rent_price_list) // 월세
        this.f_monthly_rent_max = Math.max(...month_rent_price_list) // 월세
        console.log("this.f_monthly_rent_deposit_min == " + this.f_monthly_rent_deposit_min);
        console.log("this.f_monthly_rent_deposit_max == " + this.f_monthly_rent_deposit_max);
        console.log("this.f_monthly_rent_min == " + this.f_monthly_rent_min);
        console.log("this.f_monthly_rent_max == " + this.f_monthly_rent_max);
        console.log("month_rent_price_list == " + month_rent_price_list);
        if (this.f_monthly_rent_deposit_min != Infinity && this.f_monthly_rent_deposit_max != -Infinity
            && this.f_monthly_rent_min != Infinity && this.f_monthly_rent_max != -Infinity
            && (this.f_monthly_rent_deposit_min !== this.f_monthly_rent_deposit_max || this.f_monthly_rent_min !== this.f_monthly_rent_max)
          ) {
          this.month_simple = true
        } else {
          this.month_simple = false
        }
        // console.log("Site this.f_monthly_rent_deposit_min = " + this.f_monthly_rent_deposit_min);
        // console.log("Site this.f_monthly_rent_deposit_max = " + this.f_monthly_rent_deposit_max);
        // console.log("Site this.f_monthly_rent_min = " + this.f_monthly_rent_min);
        // console.log("Site this.f_monthly_rent_max = " + this.f_monthly_rent_max);

        item.f_collateral_price = Math.max(...collateral_price_list) // 담보금
        console.log("item.f_site_inquire_price == " + item.f_site_inquire_price);
        item.f_site_inquire_price = item_ho_list.filter(it => {return it.f_complete == 'N'})
          .some(it => it.f_trans_type.split(',').includes('0') && it.f_site_inquire_price == 'Y') ? 'Y' : 'N'
        item.f_site_inquire_charter = item_ho_list.filter(it => {return it.f_complete == 'N'})
          .some(it => it.f_trans_type.split(',').includes('1') && it.f_site_inquire_charter == 'Y') ? 'Y' : 'N'
        item.f_site_inquire_investment = item_ho_list.filter(it => {return it.f_complete == 'N'})
           .some(it => it.f_trans_type.split(',').includes('2') && it.f_site_inquire_investment == 'Y') ? 'Y' : 'N'
        item.f_site_inquire_month = item_ho_list.filter(it => {return it.f_complete == 'N'})
           .some(it => it.f_trans_type.split(',').includes('3') && it.f_site_inquire_month == 'Y') ? 'Y' : 'N'
      } else if (this.hoMode && item.f_site_type == 'O') {
        this.f_monthly_rent_min = item.f_monthly_rent_min // 월세보증금
        this.f_monthly_rent_max = item.f_monthly_rent_max // 월세
        this.month_simple = false;
      }
      if (item.f_site_type != 'O') {
        this.month_simple = false;
        // this.f_monthly_rent_deposit_min = item.f_monthly_rent_min // 월세보증금
        // this.f_monthly_rent_deposit_max = item.f_monthly_rent_max // 월세
        this.f_monthly_rent_min = item.f_monthly_rent_min // 월세보증금
        this.f_monthly_rent_max = item.f_monthly_rent_max // 월세
        if(item.f_monthly_rent_min == 0 && item.f_monthly_rent_max == 0)
          this.month_simple = true;
      }
      console.log("this.month_simple == " + this.month_simple);
      console.log("item.f_site_inquire_price == " + item.f_site_inquire_price);
      console.log("item.f_sale_price_min == " + item.f_sale_price_min);
      console.log("item.f_sale_price_max == " + item.f_sale_price_max);

      if (item.f_sale_price_min == Infinity && item.f_sale_price_max == -Infinity && item.f_site_inquire_price == 'N') {
        this.showTrading = false;
      } else {
        this.showTrading = true;
      }
      console.log("this.showTrading == " + this.showTrading);

      if (item.f_charter_price_min == Infinity && item.f_charter_price_max == -Infinity && item.f_site_inquire_charter == 'N') {
        this.showCharter = false;
      } else {
        this.showCharter = true;
      }

      if (item.f_invest_price_min == Infinity && item.f_invest_price_max ==  -Infinity && item.f_site_inquire_investment == 'N') {
        this.showInvestment = false;
      } else {
        this.showInvestment = true;
      }

      console.log("Site Item item.f_site_inquire_investment = " + item.f_site_inquire_investment);
      console.log("Site Item this.showInvestment = " + this.showInvestment);
      console.log("Site Item this.f_monthly_rent_min = " + this.f_monthly_rent_min);
      console.log("Site Item this.f_monthly_rent_max = " + this.f_monthly_rent_max);
      console.log("Site Item f_site_inquire_month = " + item.f_site_inquire_month);
      if (this.f_monthly_rent_min == Infinity && this.f_monthly_rent_max ==  -Infinity && item.f_site_inquire_month == 'N') {
        this.showMonth = false;
      } else {
        this.showMonth = true;
      }
      console.log("this.showMonth = " + this.showMonth);

      if (false) {
        console.log("room update false !!!!");
        this.exclusiveAreaList =
          item.f_room_list
            .filter(it => it.f_area == 'E')
            .map(it => it.f_exclusive_pyong)
            .sort((a, b) => b - a);
        this.realAreaList =
          item.f_room_list
            .filter(it => it.f_area == 'R')
            .map(it => it.f_real_pyong)
            .sort((a, b) => b - a);

        // room list는 4, 3, 2, 1.5, 1의 순서로 정열
        // room 개수가 같을시 실평이 큰것이 먼저 현시되도록...

        item.f_room_list.sort(this.sort);
        item_ho_list.sort(this.sort);

        this.roomList = [];
        let tmpList = item_ho_list.length > 0 ? item_ho_list : item.f_room_list;
        if (tmpList.length > 0) {
          let roomType = '';
          let ind = 0;

          // room type 이 다른것으로 2개를 선택한다...
          while (this.roomList.length < 2) {
            if (tmpList.length <= ind) {
              break;
            }

            let roomItem = tmpList[ind];
            if (roomItem.f_room != roomType) {
              this.roomList.push(roomItem);
              roomType = roomItem.f_room;
            }
            ind++;
          }

          // 만일 room type이 다 같다면 그중 면적이 큰것으로 2개를 택한다.
          if (this.roomList.length < 2 && tmpList.length > 1) {
            for (let idx = 1; idx < tmpList.length; idx++) {
              if (this.roomList[0].f_real_pyong != tmpList[idx].f_real_pyong) {
                this.roomList.push(tmpList[idx]);
                break;
              }
              if (this.roomList[0].f_exclusive_pyong != tmpList[idx].f_exclusive_pyong) {
                this.roomList.push(tmpList[idx]);
                break;
              }
            }
            if (this.roomList.length < 2 && this.getRoomType(this.item) > 1) {
              this.roomList.push(tmpList[1]);
            }
          }
        }
        // this.roomList의 room type이 다르다면 작은것이 먼저 현시되도록 한다.
        if (this.roomList.length > 1) {
          if (this.roomList[0].f_room != this.roomList[1].f_room) {
            this.roomList.reverse();
          }
        }
      }

    },
  },
  watch: {
    item() {
      this.init_component();
    },
  },
  mounted() {
    // this.showBtn = true;
    // this.isAdmin = true;
    // let remain_days_till_hide = this.item.f_remain_days_till_hide;
    // let remain_days_till_hide = 6;

    this.init_component();
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/_vars.scss";

.available_notify {
  color: #0660e2;
  font-size: $fs_14;
  font-family: $korean_gd_17_r;
  text-decoration-line: underline;
}
.auto_hide_warning {
  color: $text;
  font-size: $fs_18;
  font-family: $korean_gd_15_r;
  margin-left: 10px;
}
.buttons {
  display: flex;
  //justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  z-index: 0;
}

.memo_info {
  margin-top: 20px;
  align-items: center;
}

.cost_info {
  color: $black;
  font-size: $fs_16;
  font-family: $korean_gd_14_r;
  margin-left: 7px;
  margin-right: 10px;
}

.badge {
  width: 40px;
  height: 22px;
  //border: solid 2px #a1a0a0;
  color: white;
  border-radius: 4px;
  align-items: center;
  justify-content: center;
  font-size: $fs_14;
  font-family: $korean_gd_12_r;
  margin-right: 5px;
}

.cell_header {
  //height: 60px;
  align-items: center;
  padding: 5px 0 5px;
}

.sale_date {
  color: #7a7a7a;
  font-size: $fs_14;
  font-family: $korean_gd_13_r;
}

.sale_info {
  //padding-top: 0;
  //padding-bottom: 10px;
  justify-content: space-between;
  padding: 0.8em 0.3em;
  border-top: solid 1px #bebdbd;
  border-bottom: solid 1px #bebdbd;
}

.cost_item {
  margin-bottom: 7px;
  align-items: center;
}

.cost_item:last-child{
  margin-bottom: 0;
}

.vertical-layout {
  display: flex;
  flex-direction: column;
  //align-items: center;
  justify-content: center;
}

.charter_badge {
  display: inline-flex;
  width: 56px;
  height: 27px;
  border-radius: 5px;
  align-items: center;
  justify-content: center;
  color: $white;
  font-size: 16px;
  font-family: $korean_gd_14_r;
}

.image_wrapper {
  background-size: cover;
  background-position: 50% 50%;
  width: 200px;
  height: 150px;
  margin-left: 3px;
  border: solid 1.5px #d0e2fc;
  border-radius: 6px;
  overflow: hidden;
  position: relative;
  margin-top: 10px;
}

.top_right {
  position: absolute;
  top: 0.5em;
  right: 0.5em;
}

.complete_mask {
  position: absolute;
  display: flex;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  color: $white;
  font-size: $fs_25;
  font-family: $korean_gd_15_r;
}

.room_row {
  display: flex;
  width: 100%;
  justify-content: space-around;
  align-items: center;
  height: 30px;
}
.room_col {
  text-align: center;
  color: $black;
  font-size: $fs_18;
  font-family: $korean_gd_14_r;
  padding: 0 3px;
}
.divider {
  display: inline-block;
  width: 1.5px;
  background-color: #e7e5e5;
  height: 10px;
}
.divider2 {
  width: 1.5px;
  background-color: #e7e5e5;
  height: 20px;
}
.room_info {
  padding: 0.2em 0.3em;
  border-top: solid 1px #e8e7e7;
  border-bottom: solid 1px #e8e7e7;
}
.red_text {
  color: $trading;
}
.memo {
  color: $text;
  font-size: $fs_20;
  font-family: $korean_gd_14_r;
  margin-left: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 10px;
}

.bordered-view {
  margin-top: 5px;
  text-align: center;
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.08);
  border: solid 1px #e7e5e5;
  border-radius: 5px;
  padding: 4px 3px;
  margin-top: 15px;
}

.bordered-view-result {
  @extend .bordered-view;
  margin-top: 5px;
  text-align: left;
}

.bordered-view-confirm {
  @extend .bordered-view-result;
  box-shadow: none;
  margin-left: 0 !important;
  padding-left: 0.5em;
}

.button {
  width: 70px;
  height: 32px;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  color: $white;
  background-color: $c_457fff;
  font-size: $fs_14;
  font-family: $korean_gd_14_r;
  text-align: center;
  padding: 0 0.1em;
  margin-right: 10px;
}

.button2 {
  width: auto;
  height: 32px;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  color: $white;
  background-color: $c_457fff;
  font-size: $fs_14;
  font-family: $korean_gd_14_r;
  text-align: center;
  margin-right: 10px;
}

.red_btn {
  @extend .button;
  background-color: $trading1;
}

.button1 {
  @extend .button;
  background-color: $charter1;
}

.grey_button {
  @extend .button;
  background-color: $c_6c6969;
}

.auto_hide_waring {
  color: $text;
  font-size: $fs_16;
  font-family: $korean_gd_15_r;
  margin-left: 5px;
}

.site_item {
  position: relative;
  padding: 0.5em 1em 1em;
  border: 1px solid #969696;
  border-radius: 5px;
  overflow: hidden;
  //background-color: transparent;
  margin-bottom: 5px;
  //padding: 1em;
  //margin-bottom: 0.5rem;
}

.site_new {
  background-color: #FAF0F0;
  //border-color: $red;
}

.site_general {
  background-color: #F0F5FA;
  border-color: #0840BA;
}

.ho_name_label {
  font-size: $fs_12;
  color: $c_457fff;
  font-weight: bold;
}

.memo_text {
  font-size: $fs_14;
  font-family: $korean_gd_14_r;
}
</style>



// WEBPACK FOOTER //
// src/components/controls/SiteItem.vue